function setUsableVwCssProp() {
  document.documentElement.style.setProperty('--usable-vw', `${document.documentElement.clientWidth}px`);
}

module.exports.setUsableVwCssProp = setUsableVwCssProp